module.exports = __webpack_public_path__ + "d2eae2774c1948a13da28e2ca9bf09ac.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ushahidi-platform-pattern-library/assets/img/icons/loop-circular.svg
// module id = 945
// module chunks = 0